import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllRelationFolderBookIdsByBooks = (bookIds: string[] | undefined) : string[] => {
  const relationFolderBookDb = useSelector((state: RootState) => state.relationFolderBookDb);
  let ids: string[] = []; 
  bookIds?.forEach(bookId => {
    const additionalIds = Object.keys(relationFolderBookDb.relationFolderBooks).filter(
      id => relationFolderBookDb.relationFolderBooks[id].bookId === bookId);
    ids.push(...additionalIds);
  });

  return ids;
}

export default useAllRelationFolderBookIdsByBooks;
